export function isIntegratedOfferLevel(level?: string): boolean {
    return level?.endsWith('-io') ?? false;
}
